import { render, staticRenderFns } from "./StudentsInSchool.vue?vue&type=template&id=293b443c&scoped=true"
import script from "./StudentsInSchool.vue?vue&type=script&lang=js"
export * from "./StudentsInSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293b443c",
  null
  
)

export default component.exports